/**
 * The item route's segment as page links write it: an item id, or the issue
 * key a typed-page link carries (`/trackers/item/NIM-12`). A key is replaced
 * by its item's id once the records are loaded, keeping the list context, so
 * the address bar and everything below see the id the route has always held.
 */
import type { ComponentProps } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTrackerDataSelector } from '@nimbalyst/collab-bundle/trackers-ui';
import { TrackerItemSurface } from '../trackers/TrackerItemSurface';
import { useTrackersShell } from '../trackers/TrackersShell';
import { orgTrackerItemPath } from '../routing';
import { resolveTrackerItemRef } from './consoleLinkLanding';

export function TrackerItemByRef({ itemId, ...props }: ComponentProps<typeof TrackerItemSurface>) {
  const { team, projectId } = useTrackersShell();
  const { search } = useLocation();
  const recordsById = useTrackerDataSelector(state => state.recordsById);
  const resolved = resolveTrackerItemRef(itemId, recordsById);
  if (resolved && resolved !== itemId) {
    return <Navigate to={`${orgTrackerItemPath(team, projectId, resolved)}${search}`} replace />;
  }
  return <TrackerItemSurface itemId={itemId} {...props} />;
}
